module.exports = __webpack_public_path__ + "static/mariner-logo-df37294c3b09a32d9f3424f52de6ad9b.png";